import { render, staticRenderFns } from "./multipleChoice4.vue?vue&type=template&id=de7762aa&scoped=true"
import script from "./multipleChoice4.vue?vue&type=script&lang=js"
export * from "./multipleChoice4.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice4.vue?vue&type=style&index=0&id=de7762aa&prod&lang=css"
import style1 from "./multipleChoice4.vue?vue&type=style&index=1&id=de7762aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7762aa",
  null
  
)

export default component.exports